
import {
    ColumnRank,
    ColumnName,
    ColumnNoc,
    ColumnResult,
} from "components/common/TableColumns"
import { CreateColumnsCombined } from 'components/sports/ath/helper/AthHelpers'

import { COMBINED } from 'components/sports/ath/helper/AthHelpers'



export function TableColumnsComb(isEventDecathlon, rsc, eu) {
    let events = ''
    isEventDecathlon ? events = COMBINED.DECATHLON : events = COMBINED.HEPTATHLON
    let columnsExt = CreateColumnsCombined(events, rsc, eu);
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),

            ColumnResult({ disableSort: true, label: "HeaderPoints", headerClassName: 'text-end w-15' }),
            ...columnsExt,

        ]

    )
}

